module.exports = __webpack_public_path__ + "vue-dist/img/face-recognition-passed.625fc243.png";